const defaultMessage = 'Houve um erro ao criar a ordem de serviço, por favor, tente novamente mais tarde';
const handleResponse = (errorMessage) => {
  console.log(errorMessage);
  return defaultMessage;
};

export default handleResponse;
